import ImageSlider from './ImageSlider'; 


import TransportationImage1 from '../assets/images/facilities/Transport/01.jpg';
import TransportationImage2 from '../assets/images/facilities/Transport/02.jpg';
import TransportationImage3 from '../assets/images/facilities/Transport/03.jpg';


const images = [
    { src: TransportationImage1, altText: 'Transportation-1' },
    { src: TransportationImage2, altText: 'Transportation-2' },
    { src: TransportationImage3, altText: 'Transportation-3' },
];
const transportationData = [
    {
      route: "Route A",
      schedule: [
        { time: "7:00 AM", stop: "School" },
        { time: "7:15 AM", stop: "Indiranagar" },
        { time: "7:30 AM", stop:  "Kodiveri" },
      ],
      vehicle: {
        busNumber: "B101",
        driver: "Drive Name",
        capacity: 40,
      },
      locations: ["School", "Indiranagar", "Kodiveri"],
    },
    {
      route: "Route B",
      schedule: [
        { time: "7:10 AM", stop: "School" },
        { time: "7:25 AM", stop: "Rangasamudram" },
        { time: "7:40 AM", stop: "SRT Corner" },
      ],
      vehicle: {
        busNumber: "B102",
        driver: "Driver Name",
        capacity: 50,
      },
      locations: ["School", "Rangasamudram", "SRT Corner"],
    },
  ];
const Transportation = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                        SRN School Transportation
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first ">
                        <div className="text px-4">
                    
    
      {transportationData.map((routeData, index) => (
        <div key={index} className="route-info">
          <h2>{routeData.route}</h2>
          <h3>Schedule:</h3>
          <ul>
            {routeData.schedule.map((item, idx) => (
              <li key={idx}>
                {item.time} - {item.stop}
              </li>
            ))}
          </ul>
          <h3>Vehicle Details:</h3>
          <p>Bus Number: {routeData.vehicle.busNumber}</p>
          <p>Driver: {routeData.vehicle.driver}</p>
          <p>Capacity: {routeData.vehicle.capacity} students</p>
          <h3>Pickup and Drop Locations:</h3>
          <ul>
            {routeData.locations.map((location, idx) => (
              <li key={idx}>{location}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
                        
                    </div>
                    <div className=" col-md-4 order-md-first ">
                    <ImageSlider images={images} />              
                    </div>
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default Transportation;
